import React, { useState } from 'react'
import { BtnV2, Link, l, Modal } from '@manychat/manyui'

import { MetaDeletionPayload } from 'common/core/components/NotifyBar/NotifyInterfaces'
import { ChannelType } from 'common/core/constants/ChannelType'
import { SettingsTabType } from 'common/settings/constants/SettingsTabType'
import { typedRouting } from 'utils/router'

import cm from './common.module.css'

interface MetaDeletionChannelNotificationProps {
  day: 0 | 15 | 27
  data: MetaDeletionPayload
}

const SETTING_TABS = {
  [ChannelType.INSTAGRAM]: SettingsTabType.INSTAGRAM,
  [ChannelType.FB]: SettingsTabType.MESSENGER,
}

export const MetaDeletionChannelNotification = ({
  day,
  data,
}: MetaDeletionChannelNotificationProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleOnClick = () => {
    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <span className="m-r-xs">
        {l.translate('{channel_title} will be disconnected on {deletion_date}', {
          channel_title: data.channel_title,
          deletion_date: l.date(data.deletion_date),
        })}
      </span>

      <Link className={cm.link} onClick={handleOnClick}>
        {l.translate('Read more')}
      </Link>

      <Modal
        width={460}
        title={l.translate('Channel disconnection')}
        open={isModalOpen}
        buttons={[
          <BtnV2
            href={typedRouting.linkBuilder.settings({ hash: SETTING_TABS[data.channel_type] })}
            as="a"
            variant="primary"
          >
            {l.translate('Manage channel')}
          </BtnV2>,
        ]}
        onRequestClose={handleOnClick}
      >
        {day === 0 && (
          <>
            <p className="font-medium">
              {l.translate(
                '{channel_title} will be disconnected from this account on {deletion_date}.',
                {
                  channel_title: data.channel_title,
                  deletion_date: l.date(data.deletion_date),
                },
              )}
            </p>
            <p>
              {l.translate(
                'Meta asked us to delete the related data. Messaging may stop working before then. Your account and Automations stay. To keep messaging, connect a different Instagram or Messenger account.',
              )}
            </p>
          </>
        )}

        {day === 15 && (
          <>
            <p className="font-medium">
              {l.translate(
                '{channel_title} will still be disconnected from this account on {deletion_date}.',
                {
                  channel_title: data.channel_title,
                  deletion_date: l.date(data.deletion_date),
                },
              )}
            </p>
            <p>
              {l.translate(
                'Nothing has changed since our first notice. Your account and Automations stay, and Contacts keep their tags and custom fields. To keep messaging, connect a different Instagram or Messenger account.',
              )}
            </p>
          </>
        )}

        {day === 27 && (
          <>
            <p className="font-medium">
              {l.translate(
                'Final notice: {channel_title} will be disconnected from this account on {deletion_date}.',
                {
                  channel_title: data.channel_title,
                  deletion_date: l.date(data.deletion_date),
                },
              )}
            </p>
            <p>
              {l.translate(
                'Your account and Automations stay, and Contacts keep their tags and custom fields. To keep messaging, connect a different Instagram or Messenger account.',
              )}
            </p>
          </>
        )}
      </Modal>
    </>
  )
}
